module.exports = __webpack_public_path__ + "static/media/09_MINS-2.3-EQ-10_1.94d7cb18.svg";